
import PreviewSupport from 'diagram-js/lib/features/preview-support/PreviewSupport';
import {ModelingUtil} from "@ispm/shared/bpmn-io/modeling-util";
import EventBus from "diagram-js/lib/core/EventBus";

export class PathwayPreviewSupport extends PreviewSupport {


    constructor(private elementRegistry,private eventBus: EventBus, private canvas, private styles) {
        super(elementRegistry,eventBus, canvas, styles);
    }


    addDragger(shape, group) {
        if (this.elementRegistry.getGraphics(shape) && !ModelingUtil.hasDeletionTrackingChange(shape)) {
            return super.addDragger(shape, group);
        }
    }
}
